import { render, staticRenderFns } from "./showPopupInfo.vue?vue&type=template&id=64716caa&"
import script from "./showPopupInfo.vue?vue&type=script&lang=js&"
export * from "./showPopupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports